import { useQuery } from "@tanstack/react-query";
import { getPatientDocumentDefaultExpirationDate } from "../patientDocuments/getPatientDocumentDefaultExpirationDate";

const fetchDefaultTypeExpirationDate = async ({
  documentType,
  createdDate,
}) => {
  const response = await getPatientDocumentDefaultExpirationDate({
    documentType,
    createdDate,
  });
  return response.data;
};

const useDocumentTypeDefaultExpirationDate = (params, options = {}) => {
  return useQuery(
    ["defaultTypeExpirationDate", params],
    () => fetchDefaultTypeExpirationDate(params),
    options,
  );
};

export default useDocumentTypeDefaultExpirationDate;
